import { useEffect, useState, useMemo, useRef } from "react";
import {
  getAll,
  Amount,
  exportAct1AllGradesReport,
  exportAct2AllGradesReport,
  getCountryActualCounts,
  saveCountryActualCounts,
} from "../actions/studensts";
import { useDispatch, useSelector } from "react-redux";
import Table from "./Table/Table";
import Pagination from "./Table/Pagination";
import Search from "./Table/Search";
import { exportToExcel, excelAct2TopAchievers, excelAllGradesReport, excelGrade11Report, excelUniversitiesReport, excelAllInvoicesReport, excelShippingReport, excelMoheReport, excelCollegesReport, excelSchoolsStateReport, excelMissingEnrollmentLettersReport } from "./exportToExcel";
import ColumnNavigator from "../components/ColumnNavigator";
import { heads } from "./Table/Table/config";

function Main() {
  const { students, count } = useSelector((state) => state.students);
  // Create a fast index for students by national ID (or any unique field)
  const studentIndex = useMemo(() => {
    if (!students) return {};
    const index = {};
    for (const student of students) {
      if (student.id) index[student.id] = student;
    }
    return index;
  }, [students]);
  const [selected, setSelected] = useState(false);
  const [page, setPage] = useState(1);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const [search, setSearch] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [dailyAmount, setDailyAmount] = useState(0);
  const [allAmount, setAllAmount] = useState(0);
  const [selectState, setSelectState] = useState("all");
  const [act2DateFrom, setAct2DateFrom] = useState("");
  const [act2DateTo, setAct2DateTo] = useState("");
  // Grades range for the Top Achievers export — defaults to the historical 30–36.
  const [act2ScoreFrom, setAct2ScoreFrom] = useState("30");
  const [act2ScoreTo, setAct2ScoreTo] = useState("36");
  const [act2Loading, setAct2Loading] = useState(false);
  const [showAct2Modal, setShowAct2Modal] = useState(false);
  const [allGradesDateFrom, setAllGradesDateFrom] = useState("");
  const [allGradesDateTo, setAllGradesDateTo] = useState("");
  const [allGradesLoading, setAllGradesLoading] = useState(false);
  const [showAllGradesModal, setShowAllGradesModal] = useState(false);
  const [allGradesDateType, setAllGradesDateType] = useState("auth");
  // Grade 11 Report (reuses the All Grades data, filtered to grade 11 + score 25–36)
  const [grade11DateFrom, setGrade11DateFrom] = useState("");
  const [grade11DateTo, setGrade11DateTo] = useState("");
  const [grade11DateType, setGrade11DateType] = useState("auth");
  const [grade11Loading, setGrade11Loading] = useState(false);
  const [showGrade11Modal, setShowGrade11Modal] = useState(false);
  // Universities Report (Public/Private)
  const [showUnivModal, setShowUnivModal] = useState(false);
  const [univDateFrom, setUnivDateFrom] = useState("");
  const [univDateTo, setUnivDateTo] = useState("");
  const [univLoading, setUnivLoading] = useState(false);
  // All Invoices Report
  const [showInvModal, setShowInvModal] = useState(false);
  const [invDateFrom, setInvDateFrom] = useState("");
  const [invDateTo, setInvDateTo] = useState("");
  const [invLoading, setInvLoading] = useState(false);
  // Shipping Report
  const [showShippingModal, setShowShippingModal] = useState(false);
  const [shippingDateFrom, setShippingDateFrom] = useState("");
  const [shippingDateTo, setShippingDateTo] = useState("");
  const [shippingLoading, setShippingLoading] = useState(false);
  // MOHE Report
  const [showMoheModal, setShowMoheModal] = useState(false);
  const [moheDateFrom, setMoheDateFrom] = useState("");
  const [moheDateTo, setMoheDateTo] = useState("");
  const [moheLoading, setMoheLoading] = useState(false);
  // Colleges Report
  const [showCollegesModal, setShowCollegesModal] = useState(false);
  const [collegesDateFrom, setCollegesDateFrom] = useState("");
  const [collegesDateTo, setCollegesDateTo] = useState("");
  const [collegesLoading, setCollegesLoading] = useState(false);
  // Schools Report (MOE states — filtered by invoice date + selected states)
  const [showSchoolsReportModal, setShowSchoolsReportModal] = useState(false);
  const [schoolsReportDateFrom, setSchoolsReportDateFrom] = useState("");
  const [schoolsReportDateTo, setSchoolsReportDateTo] = useState("");
  const [schoolsReportStates, setSchoolsReportStates] = useState([
    "moe_hold",
    "moe_validation",
    "moe",
    "moe_pending",
  ]);
  const [schoolsReportLoading, setSchoolsReportLoading] = useState(false);
  const toggleSchoolsReportState = (value) =>
    setSchoolsReportStates((prev) =>
      prev.includes(value) ? prev.filter((s) => s !== value) : [...prev, value]
    );
  // Missing Enrollment Letters Report (any state — filtered by invoice date)
  const [showMissingEnrollmentModal, setShowMissingEnrollmentModal] = useState(false);
  const [missingEnrollmentDateFrom, setMissingEnrollmentDateFrom] = useState("");
  const [missingEnrollmentDateTo, setMissingEnrollmentDateTo] = useState("");
  const [missingEnrollmentLoading, setMissingEnrollmentLoading] = useState(false);
  // Country actual-counts editor (used inside the All Grades flow)
  const [showActualModal, setShowActualModal] = useState(false);
  const [actualLoading, setActualLoading] = useState(false);
  const [actualSaving, setActualSaving] = useState(false);
  // rows: [{ country, act1_actual, act2_actual, act1_sheet, act2_sheet }]
  const [actualRows, setActualRows] = useState([]);
  const tableRef = useRef(null);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile")).value[0];
  const canSeeAllReports =
    user.username === "admin" ||
    user.username === "asmaa" ||
    user.username === "abdelrhman" ||
    user.username === "acountant-1";
  const canSeeMissingEnrollmentReport =
    canSeeAllReports || user.username === "Agent"|| user.username === "agent" || user.username === "Yara";

  const handleNavigateToColumn = (columnIndex) => {
    if (tableRef.current) {
      tableRef.current.scrollToColumn(columnIndex);
    }
  };

  // Fetch the union of countries from the All Grades report (for the chosen
  // date range) and merge with any saved actual counts, then open the editor.
  const openActualCountsModal = async () => {
    if (!allGradesDateFrom || !allGradesDateTo) {
      alert("Please choose a From and To date first.");
      return;
    }
    setActualLoading(true);
    try {
      const [resAct1, resAct2, resSaved] = await Promise.all([
        exportAct1AllGradesReport(allGradesDateFrom, allGradesDateTo, allGradesDateType),
        exportAct2AllGradesReport(allGradesDateFrom, allGradesDateTo, allGradesDateType),
        getCountryActualCounts(),
      ]);

      const toTitle = (s) =>
        (s || "")
          .trim()
          .replace(/\s+/g, " ")
          .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

      const countryMap = new Map(); // key → { country, act1_sheet:Set, act2_sheet:Set }
      const addRows = (rows, bucket) => {
        if (!rows) return;
        for (const r of rows) {
          const label = toTitle(r["Country"]) || "Unknown";
          const key = label.toLowerCase();
          if (!countryMap.has(key))
            countryMap.set(key, { country: label, act1_sheet: new Set(), act2_sheet: new Set() });
          countryMap.get(key)[bucket].add(r["National ID"]);
        }
      };
      addRows(resAct1?.data?.data, "act1_sheet");
      addRows(resAct2?.data?.data, "act2_sheet");

      const savedMap = new Map();
      if (resSaved && resSaved.status === 200 && Array.isArray(resSaved.data.data)) {
        for (const r of resSaved.data.data) {
          savedMap.set((r.country || "").trim().toLowerCase(), r);
        }
      }

      const rows = [...countryMap.values()]
        .map(({ country, act1_sheet, act2_sheet }) => {
          const saved = savedMap.get(country.toLowerCase()) || {};
          return {
            country,
            act1_sheet: act1_sheet.size,
            act2_sheet: act2_sheet.size,
            act1_actual: saved.act1_actual ?? "",
            act2_actual: saved.act2_actual ?? "",
          };
        })
        .sort((a, b) => a.country.localeCompare(b.country));

      setActualRows(rows);
      setShowActualModal(true);
    } catch (e) {
      console.error(e);
      alert("Failed to load country counts.");
    } finally {
      setActualLoading(false);
    }
  };

  const saveActualCounts = async () => {
    setActualSaving(true);
    try {
      const payload = actualRows.map((r) => ({
        country: r.country,
        act1_actual: Number(r.act1_actual) || 0,
        act2_actual: Number(r.act2_actual) || 0,
      }));
      const res = await saveCountryActualCounts(payload);
      if (res && res.status === 200) {
        setShowActualModal(false);
      } else {
        alert("Failed to save actual counts.");
      }
    } catch (e) {
      console.error(e);
      alert("Failed to save actual counts.");
    } finally {
      setActualSaving(false);
    }
  };

  const getSelectState = (state) => {
    let newSelected = selectState;
    newSelected = state;
    setSelectState(newSelected);
  };


const getDailyAmount = async () => {
  if (user.role === 'admin') {
    setLoading1(true);
    try {
      const res = await Amount();
      if (res && res.data) {
        setDailyAmount(res.data.daily_amount);
        setAllAmount(res.data.total_amount);
      }
    } catch (error) {
      console.error('Error fetching daily amount:', error);
    } finally {
      setLoading1(false);
    }
  }
};


  // clear students on mount
  useEffect(() => {
    dispatch({ type: "CLEAR" });
    setHasSearched(false);
  }, [dispatch]);

  // update students on search term changes (immediate, no debounce since button controls it)
  useEffect(() => {
    if (!hasSearched) return;
    if (search && search.length < 3) return;
    
    // Clear students on new search to prevent flickering
    dispatch({ type: "CLEAR" });
    setLoading(true);
    dispatch(getAll(page, search)).finally(() => setLoading(false));
  }, [search, dispatch, hasSearched]);

  // update students on page changes (immediate, don't clear for smooth pagination)
  useEffect(() => {
    if (!hasSearched) return;
    if (search && search.length < 3) return;
    
    setLoading(true);
    dispatch(getAll(page, search)).finally(() => setLoading(false));
  }, [page]);

  // disabled the next button if in last page
  useEffect(() => {
    getDailyAmount();
    if (page === count?.maxPage) {
      setNextDisabled(true);
    } else {
      setNextDisabled(false);
    }
  }, [count?.maxPage, page]);

  return (
    <div>
      <div className="flex flex-wrap justify-between p-5">
        <h1 className="text-2xl p-3 text-white">Main Page</h1>
        <div className="flex flex-wrap justify-between">
          {user.role === "invoice" || user.username === "admin" ? (
            <div className="p-3">
              <h2 className="text-xl bg-green-700 p-3 rounded  text-white">
                Daily Amount:{" "}
                <span className="text-xl px-2 rounded bg-white text-red-800">
                  {loading1 ? "Loading..." : dailyAmount}
                </span>
              </h2>
            </div>
          ) : (
            ""
          )}
          {user.role === "invoice" || user.username === "admin" ? (
            <div className="p-3">
              <h2 className="text-xl bg-green-700 p-3 rounded  text-white">
                Total Amount:{" "}
                <span className="text-xl px-2 rounded bg-white text-red-800">
                  {loading1 ? "Loading..." : allAmount}
                </span>
              </h2>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div>
        <div className="w-full max-w-3xl mx-auto px-3">
          {(user.username === "asmaa" ||
            user.username === "abdelrhman" ||
            user.username === "alaa" ||
            user.username === "officer" ||
            user.username === "acountant-1") && (
            <div className="p-3 w-72 flex justify-between mx-auto">
              <div>
                <div>
                  <label className="fs-4 fw-normal text-white" htmlFor="states">
                    Select a State to Export:{" "}
                  </label>
                </div>
                <select
                  onChange={(e) => getSelectState(e.target.value)}
                  className="w-40 p-1"
                  id="states"
                >
                  <option value="all">all</option>
                  <option value="auditing">auditing</option>
                  <option value='auditing_pending'>Auditing_pending</option>
                  <option value="invoice">invoice</option>
                  <option value="invoice_wait">invoice_wait</option>
                  <option value="another_invoice">another_invoice</option>
                  <option value="request_edit">request_edit</option>
                  <option value="score_validation">score_validation</option>
                  <option value="score_request">score_request</option>
                  <option value="score_pending">score_pending</option>
                  <option value="print">print</option>
                  <option value="print_validation">print_validation</option>
                  <option value="moe_validation">moe_validation</option>
                  <option value="moe">moe</option>
                  <option value="moe_pending">moe_pending</option>
                  <option value="deliver_onsite">deliver_onsite</option>
                  <option value="aramex">aramex</option>
                  <option value="mohe_validation">mohe_validation</option>
                  <option value="mohe">mohe</option>
                  <option value="done">done</option>
                </select>
              </div>
              <button
                type="button"
                className="text-white bg-green-900 hover:bg-green-800 p-2 
                        focus:ring-4 focus:ring-green-400 font-medium rounded-lg text-sm text-center cursor-pointer"
                onClick={() => exportToExcel(selectState)}
              >
                Export
              </button>
            </div>
          )}

          {/* Reports — admin, asmaa, abdelrhman, acountant-1 see every report;
              Agent and Yara additionally see Missing Enrollment Letters only.
              Laid out as a responsive grid so the report buttons sit next to
              each other in rows instead of stacking. */}
          {canSeeMissingEnrollmentReport && (
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 p-3">
              {canSeeAllReports && (
                <>
              <button
                type="button"
                className="h-full w-full text-white bg-blue-800 hover:bg-blue-700 p-2
                        focus:ring-4 focus:ring-blue-400 font-medium rounded-lg text-sm cursor-pointer"
                onClick={() => setShowAct2Modal(true)}
              >
                ACT Top Achievers Report
              </button>

              <button
                type="button"
                className="h-full w-full text-white bg-indigo-700 hover:bg-indigo-600 p-2
                        focus:ring-4 focus:ring-indigo-400 font-medium rounded-lg text-sm cursor-pointer"
                onClick={() => setShowAllGradesModal(true)}
              >
                All Grades Report
              </button>

              <button
                type="button"
                className="h-full w-full text-white bg-teal-700 hover:bg-teal-600 p-2
                        focus:ring-4 focus:ring-teal-400 font-medium rounded-lg text-sm cursor-pointer"
                onClick={() => setShowGrade11Modal(true)}
              >
                Grade 11 Report
              </button>

              <button
                type="button"
                className="h-full w-full text-white bg-purple-800 hover:bg-purple-700 p-2
                        focus:ring-4 focus:ring-purple-400 font-medium rounded-lg text-sm cursor-pointer"
                onClick={() => setShowUnivModal(true)}
              >
                Delivery Report
              </button>

              <button
                type="button"
                className="h-full w-full text-white bg-green-800 hover:bg-green-700 p-2
                        focus:ring-4 focus:ring-green-400 font-medium rounded-lg text-sm cursor-pointer"
                onClick={() => setShowInvModal(true)}
              >
                All Invoices Report
              </button>

              <button
                type="button"
                className="h-full w-full text-white bg-indigo-800 hover:bg-indigo-700 p-2
                        focus:ring-4 focus:ring-indigo-400 font-medium rounded-lg text-sm cursor-pointer"
                onClick={() => setShowShippingModal(true)}
              >
                Shipping Report
              </button>

              <button
                type="button"
                className="h-full w-full text-white bg-purple-800 hover:bg-purple-700 p-2
                        focus:ring-4 focus:ring-purple-400 font-medium rounded-lg text-sm cursor-pointer"
                onClick={() => setShowMoheModal(true)}
              >
                MOHE Report
              </button>

              <button
                type="button"
                className="h-full w-full text-white bg-teal-800 hover:bg-teal-700 p-2
                        focus:ring-4 focus:ring-teal-400 font-medium rounded-lg text-sm cursor-pointer"
                onClick={() => setShowCollegesModal(true)}
              >
                Colleges Report
              </button>

              <button
                type="button"
                className="h-full w-full text-white bg-rose-800 hover:bg-rose-700 p-2
                        focus:ring-4 focus:ring-rose-400 font-medium rounded-lg text-sm cursor-pointer"
                onClick={() => setShowSchoolsReportModal(true)}
              >
                Schools Report
              </button>
                </>
              )}

              <button
                type="button"
                className="h-full w-full text-white bg-orange-800 hover:bg-orange-700 p-2
                        focus:ring-4 focus:ring-orange-400 font-medium rounded-lg text-sm cursor-pointer"
                onClick={() => setShowMissingEnrollmentModal(true)}
              >
                Missing Enrollment Letters
              </button>
            </div>
          )}

          <div className="max-w-md mx-auto">
            <Search
              setSearch={(val) => {
                if (val === "") {
                  // Clear everything when search is empty
                  dispatch({ type: "CLEAR" });
                  setHasSearched(false);
                } else {
                  setHasSearched(true);
                }
                setSearch(val);
              }}
              setPage={setPage}
            />
          </div>
        </div>
        <div className="overflow-auto p-3">
          {!hasSearched ? (
            <div className="text-center text-white p-20 text-2xl">
              Enter Search Term to Load Data...
            </div>
          ) : loading ? (
            <div className="text-center p-20">
              <div className="flex flex-col items-center gap-4">
                <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-orange-500"></div>
                <p className="text-white text-xl">Loading data, please wait...</p>
              </div>
            </div>
          ) : students && students.length > 0 ? (
            <>
              <div className="mb-3">
                <ColumnNavigator columns={heads} onNavigate={handleNavigateToColumn} />
              </div>
              <Table
                ref={tableRef}
                selected={selected}
                setSelected={setSelected}
                students={students}
                studentIndex={studentIndex} // Pass the index for fast lookup
              />
            </>
          ) : (
            <div className="text-center text-white p-20 text-2xl">
              No results found
            </div>
          )}
        </div>
        <div className="py-4">
          <Pagination
            page={page}
            setPage={setPage}
            maxPage={count?.maxPage}
            nextDisabled={nextDisabled}
          />
        </div>
      </div>

      {/* All Grades Report Modal */}
      {showAllGradesModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-60"
            onClick={() => setShowAllGradesModal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl p-7 w-96 z-10">
            <h2 className="text-lg font-bold text-gray-800 mb-5 border-b pb-3">
              All Grades Report
            </h2>
            <p className="text-xs text-gray-500 mb-4">
              Includes all score grades for ACT 1 and ACT 2.
            </p>
            <div className="mb-4 flex gap-4">
              <label className="flex items-center gap-1.5 text-sm font-medium text-gray-700 cursor-pointer">
                <input
                  type="radio"
                  name="allGradesDateType"
                  value="auth"
                  checked={allGradesDateType === "auth"}
                  onChange={() => setAllGradesDateType("auth")}
                  className="accent-indigo-700"
                />
                Authentication Date
              </label>
              <label className="flex items-center gap-1.5 text-sm font-medium text-gray-700 cursor-pointer">
                <input
                  type="radio"
                  name="allGradesDateType"
                  value="trial"
                  checked={allGradesDateType === "trial"}
                  onChange={() => setAllGradesDateType("trial")}
                  className="accent-indigo-700"
                />
                Trial Date
              </label>
            </div>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                From ({allGradesDateType === "trial" ? "Trial Date" : "Authentication Date"})
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-indigo-400"
                value={allGradesDateFrom}
                onChange={(e) => setAllGradesDateFrom(e.target.value)}
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                To ({allGradesDateType === "trial" ? "Trial Date" : "Authentication Date"})
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-indigo-400"
                value={allGradesDateTo}
                onChange={(e) => setAllGradesDateTo(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <button
                type="button"
                disabled={!allGradesDateFrom || !allGradesDateTo || actualLoading}
                className="w-full px-4 py-2 bg-amber-500 text-white rounded-lg hover:bg-amber-400
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={openActualCountsModal}
              >
                {actualLoading ? "Loading countries..." : "Manage Country Actual Counts"}
              </button>
              <p className="text-[11px] text-gray-500 mt-1">
                Set the real ACT 1 / ACT 2 totals per country to compute % in the Country summary.
              </p>
            </div>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg
                           hover:bg-gray-200 text-sm font-medium"
                onClick={() => setShowAllGradesModal(false)}
              >
                Cancel
              </button>
              <button
                disabled={!allGradesDateFrom || !allGradesDateTo || allGradesLoading}
                className="px-4 py-2 bg-indigo-700 text-white rounded-lg hover:bg-indigo-600
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={async () => {
                  setAllGradesLoading(true);
                  await excelAllGradesReport(allGradesDateFrom, allGradesDateTo, allGradesDateType);
                  setAllGradesLoading(false);
                  setShowAllGradesModal(false);
                }}
              >
                {allGradesLoading ? "Exporting..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Grade 11 Report Modal */}
      {showGrade11Modal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-60"
            onClick={() => setShowGrade11Modal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl p-7 w-96 z-10">
            <h2 className="text-lg font-bold text-gray-800 mb-5 border-b pb-3">
              Grade 11 Report
            </h2>
            <p className="text-xs text-gray-500 mb-4">
              Grade 11 students with a score of 25–36. Inside categories split
              into ACT 1 / ACT 2 sheets; outside categories in one sheet.
            </p>
            <div className="mb-4 flex gap-4">
              <label className="flex items-center gap-1.5 text-sm font-medium text-gray-700 cursor-pointer">
                <input
                  type="radio"
                  name="grade11DateType"
                  value="auth"
                  checked={grade11DateType === "auth"}
                  onChange={() => setGrade11DateType("auth")}
                  className="accent-teal-700"
                />
                Authentication Date
              </label>
              <label className="flex items-center gap-1.5 text-sm font-medium text-gray-700 cursor-pointer">
                <input
                  type="radio"
                  name="grade11DateType"
                  value="trial"
                  checked={grade11DateType === "trial"}
                  onChange={() => setGrade11DateType("trial")}
                  className="accent-teal-700"
                />
                Trial Date
              </label>
            </div>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                From ({grade11DateType === "trial" ? "Trial Date" : "Authentication Date"})
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-teal-400"
                value={grade11DateFrom}
                onChange={(e) => setGrade11DateFrom(e.target.value)}
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                To ({grade11DateType === "trial" ? "Trial Date" : "Authentication Date"})
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-teal-400"
                value={grade11DateTo}
                onChange={(e) => setGrade11DateTo(e.target.value)}
              />
            </div>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg
                           hover:bg-gray-200 text-sm font-medium"
                onClick={() => setShowGrade11Modal(false)}
              >
                Cancel
              </button>
              <button
                disabled={!grade11DateFrom || !grade11DateTo || grade11Loading}
                className="px-4 py-2 bg-teal-700 text-white rounded-lg hover:bg-teal-600
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={async () => {
                  setGrade11Loading(true);
                  await excelGrade11Report(grade11DateFrom, grade11DateTo, grade11DateType);
                  setGrade11Loading(false);
                  setShowGrade11Modal(false);
                }}
              >
                {grade11Loading ? "Exporting..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Country Actual Counts Editor Modal */}
      {showActualModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-60"
            onClick={() => !actualSaving && setShowActualModal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl p-6 w-[720px] max-h-[85vh] z-10 flex flex-col">
            <h2 className="text-lg font-bold text-gray-800 mb-2 border-b pb-3">
              Country Actual Counts
            </h2>
            <p className="text-xs text-gray-500 mb-3">
              Edit the real-world ACT 1 / ACT 2 totals for each country found in the Sheet.
              The Country summary will use these values to compute the % column.
            </p>
            <div className="overflow-auto border rounded-lg">
              <table className="w-full text-sm">
                <thead className="bg-indigo-700 text-white sticky top-0">
                  <tr>
                    <th className="px-3 py-2 text-left">Country</th>
                    <th className="px-3 py-2 text-center">ACT 1 (Sheet)</th>
                    <th className="px-3 py-2 text-center">ACT 1 Actual</th>
                    <th className="px-3 py-2 text-center">ACT 2 (Sheet)</th>
                    <th className="px-3 py-2 text-center">ACT 2 Actual</th>
                  </tr>
                </thead>
                <tbody>
                  {actualRows.length === 0 ? (
                    <tr>
                      <td colSpan={5} className="text-center text-gray-500 py-6">
                        No countries found in the Sheet for the selected date range.
                      </td>
                    </tr>
                  ) : (
                    actualRows.map((row, idx) => (
                      <tr key={row.country} className={idx % 2 === 0 ? "bg-indigo-50" : "bg-white"}>
                        <td className="px-3 py-1.5 font-medium text-gray-800">{row.country}</td>
                        <td className="px-3 py-1.5 text-center text-gray-700">{row.act1_sheet}</td>
                        <td className="px-3 py-1.5 text-center">
                          <input
                            type="number"
                            min="0"
                            value={row.act1_actual}
                            onChange={(e) => {
                              const v = e.target.value;
                              setActualRows((prev) => {
                                const next = [...prev];
                                next[idx] = { ...next[idx], act1_actual: v };
                                return next;
                              });
                            }}
                            className="w-24 border border-gray-300 rounded px-2 py-1 text-center
                                       focus:outline-none focus:ring-2 focus:ring-indigo-400"
                          />
                        </td>
                        <td className="px-3 py-1.5 text-center text-gray-700">{row.act2_sheet}</td>
                        <td className="px-3 py-1.5 text-center">
                          <input
                            type="number"
                            min="0"
                            value={row.act2_actual}
                            onChange={(e) => {
                              const v = e.target.value;
                              setActualRows((prev) => {
                                const next = [...prev];
                                next[idx] = { ...next[idx], act2_actual: v };
                                return next;
                              });
                            }}
                            className="w-24 border border-gray-300 rounded px-2 py-1 text-center
                                       focus:outline-none focus:ring-2 focus:ring-indigo-400"
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className="flex justify-end gap-3 mt-4">
              <button
                disabled={actualSaving}
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg
                           hover:bg-gray-200 text-sm font-medium"
                onClick={() => setShowActualModal(false)}
              >
                Close
              </button>
              <button
                disabled={actualSaving || actualRows.length === 0}
                className="px-4 py-2 bg-indigo-700 text-white rounded-lg hover:bg-indigo-600
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={saveActualCounts}
              >
                {actualSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Universities Report Modal */}
      {showUnivModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-60"
            onClick={() => setShowUnivModal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl p-7 w-96 z-10">
            <h2 className="text-lg font-bold text-gray-800 mb-5 border-b pb-3">
              Universities Report
            </h2>
            <p className="text-xs text-gray-500 mb-4">
              Public &amp; Private universities — filters by{" "}
              <span className="font-semibold">Invoice Date</span>. If a student's
              Another Invoice Date also falls in the range, it is shown alongside.
            </p>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                From (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-purple-400"
                value={univDateFrom}
                onChange={(e) => setUnivDateFrom(e.target.value)}
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                To (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-purple-400"
                value={univDateTo}
                onChange={(e) => setUnivDateTo(e.target.value)}
              />
            </div>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg
                           hover:bg-gray-200 text-sm font-medium"
                onClick={() => setShowUnivModal(false)}
              >
                Cancel
              </button>
              <button
                disabled={!univDateFrom || !univDateTo || univLoading}
                className="px-4 py-2 bg-purple-800 text-white rounded-lg hover:bg-purple-700
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={async () => {
                  setUnivLoading(true);
                  await excelUniversitiesReport(univDateFrom, univDateTo);
                  setUnivLoading(false);
                  setShowUnivModal(false);
                }}
              >
                {univLoading ? "Exporting..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* All Invoices Report Modal */}
      {showInvModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-60"
            onClick={() => setShowInvModal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl p-7 w-96 z-10">
            <h2 className="text-lg font-bold text-gray-800 mb-5 border-b pb-3">
              All Invoices Report
            </h2>
            <p className="text-xs text-gray-500 mb-4">
              Exports a summary by category and full student details filtered by{" "}
              <span className="font-semibold">Invoice Date</span>.
            </p>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                From (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-green-400"
                value={invDateFrom}
                onChange={(e) => setInvDateFrom(e.target.value)}
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                To (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-green-400"
                value={invDateTo}
                onChange={(e) => setInvDateTo(e.target.value)}
              />
            </div>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg
                           hover:bg-gray-200 text-sm font-medium"
                onClick={() => setShowInvModal(false)}
              >
                Cancel
              </button>
              <button
                disabled={!invDateFrom || !invDateTo || invLoading}
                className="px-4 py-2 bg-green-800 text-white rounded-lg hover:bg-green-700
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={async () => {
                  setInvLoading(true);
                  await excelAllInvoicesReport(invDateFrom, invDateTo);
                  setInvLoading(false);
                  setShowInvModal(false);
                }}
              >
                {invLoading ? "Exporting..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Shipping Report Modal */}
      {showShippingModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-60"
            onClick={() => setShowShippingModal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl p-7 w-96 z-10">
            <h2 className="text-lg font-bold text-gray-800 mb-5 border-b pb-3">
              Shipping Report
            </h2>
            <p className="text-xs text-gray-500 mb-4">
              Exports students whose invoice shipping amount is not 0, filtered by{" "}
              <span className="font-semibold">Invoice Date</span>.
            </p>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                From (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-indigo-400"
                value={shippingDateFrom}
                onChange={(e) => setShippingDateFrom(e.target.value)}
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                To (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-indigo-400"
                value={shippingDateTo}
                onChange={(e) => setShippingDateTo(e.target.value)}
              />
            </div>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg
                           hover:bg-gray-200 text-sm font-medium"
                onClick={() => setShowShippingModal(false)}
              >
                Cancel
              </button>
              <button
                disabled={!shippingDateFrom || !shippingDateTo || shippingLoading}
                className="px-4 py-2 bg-indigo-800 text-white rounded-lg hover:bg-indigo-700
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={async () => {
                  setShippingLoading(true);
                  await excelShippingReport(shippingDateFrom, shippingDateTo);
                  setShippingLoading(false);
                  setShowShippingModal(false);
                }}
              >
                {shippingLoading ? "Exporting..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MOHE Report Modal */}
      {showMoheModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-60"
            onClick={() => setShowMoheModal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl p-7 w-96 z-10">
            <h2 className="text-lg font-bold text-gray-800 mb-5 border-b pb-3">
              MOHE Report
            </h2>
            <p className="text-xs text-gray-500 mb-4">
              Exports students in <span className="font-semibold">MOHE</span>,{" "}
              <span className="font-semibold">MOHE Validation</span> or{" "}
              <span className="font-semibold">Done</span> state whose{" "}
              <span className="font-semibold">Invoice Date</span> falls in the
              range (students with no invoice date in range are excluded). Another
              Invoice Date is shown only when it is also in range. Student count is
              listed at the top.
            </p>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                From (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-purple-400"
                value={moheDateFrom}
                onChange={(e) => setMoheDateFrom(e.target.value)}
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                To (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-purple-400"
                value={moheDateTo}
                onChange={(e) => setMoheDateTo(e.target.value)}
              />
            </div>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg
                           hover:bg-gray-200 text-sm font-medium"
                onClick={() => setShowMoheModal(false)}
              >
                Cancel
              </button>
              <button
                disabled={!moheDateFrom || !moheDateTo || moheLoading}
                className="px-4 py-2 bg-purple-800 text-white rounded-lg hover:bg-purple-700
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={async () => {
                  setMoheLoading(true);
                  await excelMoheReport(moheDateFrom, moheDateTo);
                  setMoheLoading(false);
                  setShowMoheModal(false);
                }}
              >
                {moheLoading ? "Exporting..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Colleges Report Modal */}
      {showCollegesModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-60"
            onClick={() => setShowCollegesModal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl p-7 w-96 z-10">
            <h2 className="text-lg font-bold text-gray-800 mb-5 border-b pb-3">
              Colleges Report
            </h2>
            <p className="text-xs text-gray-500 mb-4">
              Exports per-college student counts, students grouped by college
              (a student is listed once per chosen college), and grade 11 / 12
              sheets — filtered by{" "}
              <span className="font-semibold">Invoice Date</span> (students with
              only an Another Invoice Date in range are included too).
            </p>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                From (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-teal-400"
                value={collegesDateFrom}
                onChange={(e) => setCollegesDateFrom(e.target.value)}
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                To (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-teal-400"
                value={collegesDateTo}
                onChange={(e) => setCollegesDateTo(e.target.value)}
              />
            </div>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg
                           hover:bg-gray-200 text-sm font-medium"
                onClick={() => setShowCollegesModal(false)}
              >
                Cancel
              </button>
              <button
                disabled={!collegesDateFrom || !collegesDateTo || collegesLoading}
                className="px-4 py-2 bg-teal-800 text-white rounded-lg hover:bg-teal-700
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={async () => {
                  setCollegesLoading(true);
                  await excelCollegesReport(collegesDateFrom, collegesDateTo);
                  setCollegesLoading(false);
                  setShowCollegesModal(false);
                }}
              >
                {collegesLoading ? "Exporting..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Schools Report Modal (MOE states, filtered by invoice date) */}
      {showSchoolsReportModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-60"
            onClick={() => setShowSchoolsReportModal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl p-7 w-96 z-10">
            <h2 className="text-lg font-bold text-gray-800 mb-5 border-b pb-3">
              Schools Report
            </h2>
            <p className="text-xs text-gray-500 mb-4">
              Exports students in the selected{" "}
              <span className="font-semibold">MOE states</span> whose{" "}
              <span className="font-semibold">Invoice Date</span> or{" "}
              <span className="font-semibold">Another Invoice Date</span> falls
              in the range (students with neither date in range are excluded).
              Each date is shown only when it falls in the range — if both do,
              both are shown. Counts per state and the number of students in{" "}
              <span className="font-semibold">restricted schools</span> are shown
              at the top; restricted-school students are highlighted in red.
            </p>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                From (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-rose-400"
                value={schoolsReportDateFrom}
                onChange={(e) => setSchoolsReportDateFrom(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                To (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-rose-400"
                value={schoolsReportDateTo}
                onChange={(e) => setSchoolsReportDateTo(e.target.value)}
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                States to include
              </label>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { value: "moe_hold", label: "MOE Hold" },
                  { value: "moe_validation", label: "MOE Validation" },
                  { value: "moe", label: "Sending to MOE" },
                  { value: "moe_pending", label: "MOE Pending" },
                ].map((opt) => (
                  <label
                    key={opt.value}
                    className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer
                               border border-gray-200 rounded-lg px-2 py-1.5 hover:bg-gray-50"
                  >
                    <input
                      type="checkbox"
                      className="accent-rose-700"
                      checked={schoolsReportStates.includes(opt.value)}
                      onChange={() => toggleSchoolsReportState(opt.value)}
                    />
                    {opt.label}
                  </label>
                ))}
              </div>
              {schoolsReportStates.length === 0 && (
                <p className="text-xs text-red-500 mt-2">
                  Select at least one state.
                </p>
              )}
            </div>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg
                           hover:bg-gray-200 text-sm font-medium"
                onClick={() => setShowSchoolsReportModal(false)}
              >
                Cancel
              </button>
              <button
                disabled={
                  !schoolsReportDateFrom ||
                  !schoolsReportDateTo ||
                  schoolsReportStates.length === 0 ||
                  schoolsReportLoading
                }
                className="px-4 py-2 bg-rose-800 text-white rounded-lg hover:bg-rose-700
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={async () => {
                  setSchoolsReportLoading(true);
                  await excelSchoolsStateReport(
                    schoolsReportDateFrom,
                    schoolsReportDateTo,
                    schoolsReportStates
                  );
                  setSchoolsReportLoading(false);
                  setShowSchoolsReportModal(false);
                }}
              >
                {schoolsReportLoading ? "Exporting..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Missing Enrollment Letters Report Modal (any state, filtered by invoice date) */}
      {showMissingEnrollmentModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-60"
            onClick={() => setShowMissingEnrollmentModal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl p-7 w-96 z-10">
            <h2 className="text-lg font-bold text-gray-800 mb-5 border-b pb-3">
              Missing Enrollment Letters Report
            </h2>
            <p className="text-xs text-gray-500 mb-4">
              Exports students in <span className="font-semibold">any state</span> whose{" "}
              <span className="font-semibold">Enrollment Letter Submit</span> status is{" "}
              <span className="font-semibold">No</span>, and whose{" "}
              <span className="font-semibold">Invoice Date</span> or{" "}
              <span className="font-semibold">Another Invoice Date</span> falls in the
              range. Each date is shown only when it falls in the range — if both do,
              both are shown. A per-state breakdown is shown at the top.
            </p>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                From (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-orange-400"
                value={missingEnrollmentDateFrom}
                onChange={(e) => setMissingEnrollmentDateFrom(e.target.value)}
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                To (Invoice Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-orange-400"
                value={missingEnrollmentDateTo}
                onChange={(e) => setMissingEnrollmentDateTo(e.target.value)}
              />
            </div>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg
                           hover:bg-gray-200 text-sm font-medium"
                onClick={() => setShowMissingEnrollmentModal(false)}
              >
                Cancel
              </button>
              <button
                disabled={
                  !missingEnrollmentDateFrom ||
                  !missingEnrollmentDateTo ||
                  missingEnrollmentLoading
                }
                className="px-4 py-2 bg-orange-800 text-white rounded-lg hover:bg-orange-700
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={async () => {
                  setMissingEnrollmentLoading(true);
                  await excelMissingEnrollmentLettersReport(
                    missingEnrollmentDateFrom,
                    missingEnrollmentDateTo
                  );
                  setMissingEnrollmentLoading(false);
                  setShowMissingEnrollmentModal(false);
                }}
              >
                {missingEnrollmentLoading ? "Exporting..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ACT 2 Top Achievers Modal */}
      {showAct2Modal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black bg-opacity-60"
            onClick={() => setShowAct2Modal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl p-7 w-96 z-10">
            <h2 className="text-lg font-bold text-gray-800 mb-5 border-b pb-3">
              ACT Top Achievers Report
            </h2>
            <p className="text-xs text-gray-500 mb-4">
              Filters by <span className="font-semibold">Authentication Date</span> (invoice date).
              Only students with a score inside the{" "}
              <span className="font-semibold">Grades Range</span> below (ACT 1 total score, or
              any ACT 2 subject) are included.
            </p>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                From (Authentication Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={act2DateFrom}
                onChange={(e) => setAct2DateFrom(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                To (Authentication Date)
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg p-2 text-sm
                           focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={act2DateTo}
                onChange={(e) => setAct2DateTo(e.target.value)}
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                Grades Range
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  min="1"
                  max="36"
                  placeholder="From"
                  className="w-full border border-gray-300 rounded-lg p-2 text-sm
                             focus:outline-none focus:ring-2 focus:ring-blue-400"
                  value={act2ScoreFrom}
                  onChange={(e) => setAct2ScoreFrom(e.target.value)}
                />
                <span className="text-gray-400 text-sm">–</span>
                <input
                  type="number"
                  min="1"
                  max="36"
                  placeholder="To"
                  className="w-full border border-gray-300 rounded-lg p-2 text-sm
                             focus:outline-none focus:ring-2 focus:ring-blue-400"
                  value={act2ScoreTo}
                  onChange={(e) => setAct2ScoreTo(e.target.value)}
                />
              </div>
              <p className="text-xs text-gray-400 mt-1">
                Scores run 1–36. Defaults to 30–36.
              </p>
            </div>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg
                           hover:bg-gray-200 text-sm font-medium"
                onClick={() => setShowAct2Modal(false)}
              >
                Cancel
              </button>
              <button
                disabled={
                  !act2DateFrom ||
                  !act2DateTo ||
                  act2ScoreFrom === "" ||
                  act2ScoreTo === "" ||
                  act2Loading
                }
                className="px-4 py-2 bg-blue-800 text-white rounded-lg hover:bg-blue-700
                           disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-medium"
                onClick={async () => {
                  setAct2Loading(true);
                  await excelAct2TopAchievers(
                    act2DateFrom,
                    act2DateTo,
                    act2ScoreFrom,
                    act2ScoreTo
                  );
                  setAct2Loading(false);
                  setShowAct2Modal(false);
                }}
              >
                {act2Loading ? "Exporting..." : "Export Excel"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Main;